import React, { useState } from "react";
import Popup from "reactjs-popup";
import { Button } from "react-bootstrap";
import { Loading } from "../components/Loading";
import "../styles/PopUps.css";

const EarlyWarningRejectPopUp = ({ setIsOpen, onRequestReject, request, onConfirm, onCancel, currentUser }) => {
	const [open, setOpen] = useState(true);
	const [isLoading, setIsLoading] = useState(false);
	const [sendEmail, setSendEmail] = useState(true);
	console.log(request);

	const closeModal = () => {
		setOpen(false);
		setIsOpen(false);
		setIsLoading(false);
	};

	//Calls the onConfirm callback with the selected email option,
	const handleConfirm = () => {
		setIsLoading(true);
		if (onConfirm) onConfirm(sendEmail);
		setIsLoading(false);
		setOpen(false);
		setIsOpen(false);
	};

	return (
		<div>
			<Popup open={open} closeOnDocumentClick={false}>
				<div className="reject-popup-area">
					{isLoading ? (
						<div style={{ paddingLeft: "230px" }}>
							<Loading loadingText={"Deleting..."} />
						</div>
					) : (
						<>
							<>
								<h4 className="earlywarning-reject-header">Early Warning Adverse Action </h4>
								<div className="reject-radio-labels">
									<div>
										<label>
											<input type="radio" name="emailOption" value="sendEmail" checked={sendEmail} onChange={() => setSendEmail(true)} />
											<span className="radio-label-text">Send Early Warning Adverse Action email</span>
										</label>
									</div>
									<div>
										<label>
											<input type="radio" name="emailOption" value="doNotSendEmail" checked={!sendEmail} onChange={() => setSendEmail(false)} />
											<span className="radio-label-text">Do not send email</span>
										</label>
									</div>
								</div>

								<div className="reject-buttons-container">
										<Button variant="primary" className="reject-buttons" onClick={handleConfirm}>
										Submit
									</Button>
									<Button variant="primary" className="reject-buttons" onClick={closeModal}>
										Cancel
									</Button>
								</div>
							</>
						</>
					)}
				</div>
			</Popup>
		</div>
	);
};
export default EarlyWarningRejectPopUp;
